import "./main.css";

import { init, reactErrorHandler } from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import { SanityEditor } from "./components/SanityEditor";
import { Router } from "./router";
import { store } from "./state/store";
import { ComponentsProvider } from "./utilities/components";
import { initPlaybookPerspective } from "./utilities/playbook";
import { posthog } from "./utilities/posthog";
import { initStaffSession } from "./utilities/staffSession";

const prod = import.meta.env.PROD;
const environment = import.meta.env.MODE;
const isRelease = prod && ["production", "staging"].includes(environment);
init({
  enabled: isRelease,
  dsn: "https://1507fe0ba60cd8f1f895b54cf419d60a@o4506870612688896.ingest.us.sentry.io/4510314166222848",
  environment,
});

initStaffSession();
const playbookPreview = initPlaybookPerspective();

createRoot(document.getElementById("root")!, {
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.error(error, errorInfo.componentStack);
  }),
}).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <Provider store={store}>
        <BrowserRouter>
          <ComponentsProvider>
            <Router />
            {playbookPreview && <SanityEditor />}
          </ComponentsProvider>
        </BrowserRouter>
      </Provider>
    </PostHogProvider>
  </StrictMode>,
);
